export default __webpack_public_path__ + "static/media/circle-check.198b4053.svg";